module.exports = __webpack_public_path__ + "static/media/waic-liji-pay.d9670a24.png";